import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext.jsx";
import { OktaSessionProvider } from "./okta/OktaSessionContext.jsx";
import { QuotaProvider } from "./context/QuotaContext.jsx";
import { UserProvider } from "./context/UserContext.jsx";
import App from "./App.jsx";
import "./index.css";

// Clear stale state: if a ReferenceError occurs, wipe sessionStorage and reload once.
// This prevents a blank screen if persisted state triggers a crash during startup.
const IDWIZ_REFERR_RECOVERY_KEY = "idwiz.referrRecoveryOnce.v1";
function recoverFromReferenceError(err) {
  try {
    if (!(err instanceof ReferenceError)) return;
    const alreadyRecovered = localStorage.getItem(IDWIZ_REFERR_RECOVERY_KEY) === "1";
    if (alreadyRecovered) return;
    localStorage.setItem(IDWIZ_REFERR_RECOVERY_KEY, "1");
    try {
      sessionStorage.clear();
    } catch {
      /* ignore */
    }
    window.location.reload();
  } catch {
    /* ignore */
  }
}

window.addEventListener("error", (e) => recoverFromReferenceError(e?.error));
window.addEventListener("unhandledrejection", (e) => recoverFromReferenceError(e?.reason));

// If the app mounts successfully, clear the one-shot recovery flag shortly after.
window.setTimeout(() => {
  try {
    localStorage.removeItem(IDWIZ_REFERR_RECOVERY_KEY);
  } catch {
    /* ignore */
  }
}, 4000);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <OktaSessionProvider>
        <AuthProvider>
          <UserProvider>
            <QuotaProvider>
              <App />
            </QuotaProvider>
          </UserProvider>
        </AuthProvider>
      </OktaSessionProvider>
    </BrowserRouter>
  </React.StrictMode>
);
